// Format a millisecond DURATION as H+:MM:SS. Unlike formatTimeToClock (a
// wall-clock formatter that wraps hours at 24), this never caps the hours, so
// cumulative totals like "166:50:30" render correctly. Hours are padded to at
// least two digits but grow past 99 as needed.
export const formatDuration = (millis) => {
  const ms = millis > 0 ? millis : 0;
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    seconds.toString().padStart(2, "0"),
  ].join(":");
};
